import { render, staticRenderFns } from "./handler.vue?vue&type=template&id=1b8a5b16"
import script from "./handler.vue?vue&type=script&lang=js"
export * from "./handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports